<template>
  <add-forwarder v-if="selection.type === 'email'"
                 @set-domain="setDomain"
                 @close="triggerAddForwarder"
                 @action-completed="getForwarders"
  />
</template>

<script>
import { mapActions } from 'vuex'
import AddForwarder from './Modals/AddForwarder'

export default {
  name: 'CreateForwarder',
  components: {
    AddForwarder,
  },
  props: {
    selection: {
      type: Object
    }
  },
  data: () => ({
    tab: 0,
    forwarder: false,
    domain_forwarder: false,
    domain: ''
  }),
  methods: {
    ...mapActions({
      setForwarderDomain: 'email/setForwarderDomain',
      // setForwarders: 'email/setForwarders'
    }),
    triggerAddForwarder () {
      this.forwarder = !this.forwarder
    },
    triggerAddDomainForwarder () {
      this.domain_forwarder = !this.domain_forwarder
    },
    setDomain (payload) {
      this.domain = payload
    },
    async getForwarders () {
      try {
        this.setForwarderDomain(this.domain)
        this.$emit('update')
        // await this.setForwarders()
      } catch (e) {
        this.reportError(e)
      }
    }
  }
}
</script>
